import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Divider, Skeleton } from '@mui/material';
import { CustomReactSelect, CustomAccordion, CustomButton } from '../../shared';
import { LIST, PARTNERS } from './constants';
import { getFieldValue, getPartnersChannels, updateFieldsValue } from '../../../redux/thunks/adminSettingsThunk';
import { useDispatch, useSelector } from 'react-redux';
import { actions, updateFieldValueData } from '../../../redux/reducers/adminSettingsReducer';
import {FileSetupDataSkeleton, FileSetupSkeleton} from './skeleton';

const FileSetup = (props) => {
  const { } = props;
  const { company } = useSelector((state) => state.company);
  const dispatch = useDispatch()
  const { isLoading,fileSetup} = useSelector((state) => state.adminSettings)
  const {fileSetupData, selectedPartner, fieldValueData, isFileSetupLoading} = fileSetup

  const handlePartner = (option) => {
    dispatch(actions.updateSelectedPartner(option))
    dispatch(getFieldValue({companyId: company.id,partnerId: option.id}))
  };

  const onChangeValue = (index, i, value) => {
    dispatch(actions.updateFieldValueData({ index, i, value }));
  };

  const Save = async () => {
    let data = [];
    fieldValueData.forEach(item => {
      item.filesetupfields.forEach(obj => {
        if (obj.filesetupfieldmapping && obj.filesetupfieldmapping?.value) {
          data.push({ file_setup_field_id: obj.id, company_id: company.id, value: obj.filesetupfieldmapping.value, channel_id: selectedPartner.id });
        }
      });
    });
    dispatch(updateFieldsValue({companyId: company.id,
      partnerId: selectedPartner.id, data: { type_field: data }}));
  }

  useEffect(() => {
    if(company.id){
      dispatch(actions.updateSelectedPartner([]));
      dispatch(actions.updateFieldValueData([]));
      dispatch(getPartnersChannels({ companyId: company.id}));
    }
  },[company.id])

  const handleList = (list,i) => {
    return (<Grid container spacing={'24px'}>
      <Grid item xs={12}>
        <Grid container spacing={'24px'} className="flex-row">
          <Grid item xs={4}>
            <Box>
              <Typography className="text-md-medium gray-700">
                PFIQ Format
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box>
              <Typography className="text-md-medium gray-700">
                Client Format
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Divider className="border-1-gray mt-24px" />
      </Grid>

      {list?.map((row,index) => (<Grid item xs={12}>
        <Grid container spacing={'24px'} className="flex-row-center-start" key={row.field_name}>
          <Grid item xs={4}>
            <Box>
              <Typography className="text-sm-medium gray-700">
                {row.field_name}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box className='max-width-70'>
              <input type="text" className='custom-text-field text-md-regular' 
              placeholder={row.field_name}
              value={row.filesetupfieldmapping ? row.filesetupfieldmapping.value : ''}
              onChange={e => { onChangeValue(i, index, e.target.value) }}
              />
            </Box>
          </Grid>
        </Grid>
        <Divider className="border-1-gray mt-24px" />
      </Grid>))}

      <Grid item xs={12}>
        <Box className="flex-row-end-center padding-tb-0-rl-32">
          <Box>
            <CustomButton
              title="Cancel"
              titleColor="#344054"
              buttonColor="#FFFFFF"
            />
          </Box>
          <Box>
            <CustomButton
              title="Save Changes"
              titleColor="#FFFFFF"
              buttonColor="#AD509E"
              handleClick = {() => Save()}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>)
  };

  return (
    <>
  {isLoading ? (
    <FileSetupSkeleton />
  ) : (
    <Grid container spacing={'24px'} sx={{ zIndex:'9' }}>
      <Grid item xs={12}>
        <Box className="max-width-30">
          <CustomReactSelect
            options={fileSetupData}
            handleFilter={(e) => handlePartner(e)}
            placeholder={<div>Select Partner</div>}
            selectedOption={selectedPartner}
          />
        </Box>
      </Grid>
      {selectedPartner.length === 0 ? (
        <Grid item className='border-1px-solid mt-3' xs={12} height={200} display='flex' justifyContent='center' alignItems='center'>
          <Box className='text-center'>
            <Typography className='text-md-medium gray-700'>
              Please select a partner
            </Typography>
          </Box>
        </Grid>
      ) : (
        fieldValueData ? fieldValueData?.map((item, i) => (
          <Grid item xs={12} key={i}>
            <CustomAccordion
              title={item.name}
              component={handleList(item.filesetupfields, i)}
              accordionContainerBackground="bg-gray-50"
              accordionDetailsBackground='bg-gray-50'
              acoordianDetailsPadding="padding-24px"
            />
          </Grid>
        )) : (
          <Grid item xs={12}>
            <Box className="text-center">
              <Typography className='text-sm-medium gray-700'>Empty!</Typography>
            </Box>
          </Grid>
        )
      )}
    </Grid>
  )}
</>
  
  )
}

export default FileSetup;